





















import windowMixin from "@/utils/windowMixin";

import Menu from "./Menu.vue";
import Search from "./Search.vue";

import toTitleCase from "@/utils/toTitleCase";

export default windowMixin.extend({
  name: "Body",
  components: { Menu, Search },
  computed: {
    currentRoute() {
      const route = this.$route;

      const resource = route.params.name;

      if (resource) {
        return toTitleCase(resource.replace("-", " "));
      }

      return route.name;
    },
  },
});
